<template>
  <v-data-table
    :headers="headers"
    :items="filteredMedicalRequestItems"
    sort-by="name"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo serviço
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      :hide-details="errors.name === undefined"
                      :error-messages="errors.name"
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>

                <v-row dense align="center">
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      :hide-details="errors.warelineId === undefined"
                      :error-messages="errors.warelineId"
                      v-model="editedItem.warelineId"
                      label="Wareline Id"
                    />
                  </v-col>

                  <v-col cols="auto">
                    <v-switch
                      hide-details
                      v-model="editedItem.visible"
                      label="Visivel"
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.visible="{ item }">
      {{ item.visible ? "Sim" : "Não" }}
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_service"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_service"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há serviços
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "MedicalRequestList",
  props: {
    medicalRequestItems: Array,
    medicalRequestType: String,
    refreshList: Function,
  },
  data() {
    return {
      dialog: null,
      editedItem: {
        visible: true,
      },
      defaultItem: {
        visible: true,
      },
      editedIndex: -1,
      filter: "",
      errors: {},
      headers: [
        { text: "Nome", value: "name" },
        { text: "Wareline Id", value: "warelineId" },
        { text: "Visivel", value: "visible" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredMedicalRequestItems() {
      let medicalRequestItems = this.lodash.filter(this.medicalRequestItems, {
        medicalRequestType: this.medicalRequestType,
      });

      if (this.filter) {
        medicalRequestItems = this.lodash.filter(
          medicalRequestItems,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return medicalRequestItems;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Novo facilitador"
        : "Editar facilitador";
    },
  },
  methods: {
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.editedItem.name) {
        this.errors.name = errorMsg;
      }
      if (!this.editedItem.warelineId) {
        this.errors.warelineId = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    editItem(item) {
      this.editedIndex = this.filteredMedicalRequestItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse serviço?")) {
        this.apolloMutate({
          mutation: require("@/graphql/medical_request/delete_medical_request_item.gql"),
          variables: {
            medicalRequestItemId: item.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Serviço deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/medical_request/save_medical_request_item.gql"),
        variables: {
          medicalRequestItemId: this.lodash.get(this.editedItem, "id", ""),
          name: this.editedItem.name,
          medicalRequestType: this.medicalRequestType,
          warelineId: this.editedItem.warelineId,
          visible: this.editedItem.visible,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
